<template>
  <body class="main-body">
    <div class="flex-container">
      <!-- header -->
      <div class="company-header">
        <div class="left-box">
          <p class="-company">{{ messageCompany.company_name }}</p>
          <p class="-name">{{ messageViewSeeker.name }} 様</p>
        </div>
      </div>
      <div style="position: fixed; z-index: 1000; width: 100vw; height: 100vh; border-bottom-right-radius: 10px; border-bottom-left-radius: 10px; background: white; top: 0; left: 0;" v-if="!emailList">
        <Loading/>
      </div>
      <!-- チャット画面 -->
      <div class="main-container">
        <div class="chat-dialog chat-scroll" v-if="emailList.length > 0">
          <MessageBalloon
            v-for="(email,index) in emailList" :key="index"
            :bcc="email.adress_bcc"
            :cc="email.adress_cc"
            :from="email.adress_from"
            :created="displayDate(email)"
            :content="email.email_content"
            :subject="email.email_subject"
            :isReceived="email.is_received"
            :name="email.name"
            :to="email.to_email"
            v-if="isLogin"
          >
          </MessageBalloon>
          <div style="height: 42px; width: 200px;"></div>
          <div style="height: 176px;"></div>
        </div>
        <!-- emaillistが取得できなかった時 -->
        <div class="chat-dialog" v-else>
          <p>メッセージがありません。</p>
        </div>
      </div>
      <!-- 入力フォーム -->
      <div class="parent-form" style="height: 200px" :class="{'no-input-form': color.inputType==0}">
        <div class="child-form" style="height: 200px" v-if="color.inputType!=0">
          <b-field>
            <Picker title='絵文字を選択' @select="selectEmoji" style="position: fixed; bottom: 70px; right: 12px;" v-show="isOpenEmoji"/>
            <textarea
                class="disp-scroll"
                placeholder="こちらにメッセージをご入力ください"
                v-model="sendMail.content"
                @keydown.ctrl.enter="submit()"
                @keydown.meta.enter="submit()"
                style="height: 180px;border-bottom-left-radius: 10px; background: rgba(255, 255, 255, 0) !important;overflow-y: auto;">
            </textarea>
            <div class="btn-menu">
                <button class="button input-button"
                        @click="isOpenEmoji=!isOpenEmoji">
                <span class="mdi mdi-emoticon" style="color: #333;"></span>
                </button>
                <button class="button input-button"
                        @click="submit()">
                <span class="mdi mdi-send" style="color: #333;"></span>
                </button>
            </div>
          </b-field>
        </div>
      </div>
    </div>
  </body>
</template>

<script>
import { mapState }      from 'vuex'
import moment                  from 'moment'
import MessageBalloon          from '@/components/ui/MessageBalloon'
import Loading                 from '@/components/animations/Loading'
import { Emoji, Picker }       from 'emoji-mart-vue'
import chatbotSingleMixin      from '@/mixins/chatbotSingleMixin'
import connectCheckMixin from '@/mixins/connectCheckMixin'
import {
  isOffDuty,
  getWorkDayMessage,
  getWorkTimeMessage,
} from '@/functions/robo/roboOffDuty'
export default {
  components: {
    Emoji,
    Picker,
    Loading,
    MessageBalloon,
  },
  mixins: [
    chatbotSingleMixin,
    connectCheckMixin
  ],
  computed: {
    ...mapState('directtalk', ['emailList']),
    ...mapState('auth', ['messageViewSeeker','messageCompany','isMessageView']),
  },
  props: {
    seekerid: {
      type: String
    },
  },
  data () {
    return {
      isOpenEmoji: false,
      sendMail: {
        content: '',
      },
      isLogin: false,
    }
  },
  mounted () {
    // ログインのチェック
    this.isLogin = JSON.parse(localStorage.getItem('isLogin'))
    if (this.isLogin){
      // seekerのidに紐づくEmaillogの取得
      this.$store.dispatch('directtalk/getEmailList',{ seeker_id : this.seekerid })
        .then(() => {
          this.scrollDown()
        })
      // seeker情報が保持できていない場合の再取得処理
      if(!this.messageViewSeeker.id){
        this.$store.dispatch('auth/repossessionSeeker',{ seeker_id : this.seekerid })
          .then(() => {
            // seekerのgroupに紐づく会社情報の取得
            this.$store.dispatch('auth/getMessageCompany',{ company_id : this.messageViewSeeker.group })
          })
      }
      else{
        // seekerのgroupに紐づく会社情報の取得
        this.$store.dispatch('auth/getMessageCompany',{ company_id : this.messageViewSeeker.group })
      }
    }else{
      alert('再度ログインを行ってください')
      // MessageLoginへの遷移処理
      this.$router.push('/message_login/' + this.seekerid)
    }
  },
  methods: {
    displayDate(email) {
      if (!isNaN(email.created_at)) {
        return new Date(email.created_at)
      } else {
        return new Date(email.created_at)
      }
    },
    selectEmoji (emoji) {
      this.sendMail.content += emoji.native
      this.isOpenEmoji = false
    },
    submit () {
      // 空入力チェック
      if (this.sendMail.content !== '') {
        var today = new Date()
        // メール送信用
        var sendData = {
          seeker  : this.messageViewSeeker.id,
          content : this.sendMail.content,
          company : this.messageCompany.company_hash,
        }
        this.$store.dispatch('directtalk/sendMessage',sendData)
        // テキストエリアの入力内容の初期化
        this.sendMail.content = ""
        this.scrollDown()
      }else{
        alert('メッセージを入力してください')
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
html, body, .main-body {
  width: 100vw;
  height: 100vh !important;
  max-width: 500px;
  overflow: hidden !important;
  margin: 0 auto;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
}
.flex-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.main-container {
  display: flex;
  flex-direction: column;
  height: calc(100% - 252px);
  position: relative;
  box-shadow: 0 2px 4px 2px rgba(0,0,0,0.1);
}
.loading-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #fff;
  box-shadow: 0 2px 4px 2px rgba(0,0,0,0.1);
}
.entry {
  font-weight: bold;
}
.button-wrapper {
  .button {
    margin-top: 24px;
    width: 160px;
  }
}
.company-header{
  background: #f8f8f8;
  height: 72px;
  padding: 4px 24px;
  display: flex;
  justify-content: center;
  flex-direction: column-reverse;
  box-shadow: 0 2px 4px 2px rgba(0,0,0,0.1);
  .-name {
    text-align: left;
    font-size: 16px;
    font-weight: 600;
  }
  .-company {
    text-align: left;
    font-size: 13px;
  }
}
.chat-dialog {
  height: 100%;
  scroll-behavior: smooth;
  background-color: #fff;
}
.chat-scroll {
  overflow: scroll !important;
}
.chat-scroll::-webkit-scrollbar {
  width:  15px !important;
}
.input-button {
  background: transparent;
  border: none;
  resize: none;
  outline:none;
}

.parent-form {
  width: 100%;
  background: #F8F8F8;
  border-top: solid thin #CCC;
}
.child-form {
  text-align: center;
  padding-bottom: 0px !important;
  min-height: 45px;
  background: #F8F8F8;
}
textarea {
  min-width: calc(100% - 40px);
  max-width: calc(100% - 40px);
  font-size: 18px;
  border: none;
  resize: none;
  outline:none;
  line-height: 25px;
  padding-top: 10px;
  padding-left: 8px;
}
.loading-form {
  height: 20px;
  background-color: transparent;
  font-size: 16px;
}
.loading span {
  display: inline-block;
  margin: 0 -.05em;
  margin-left: 10px;
  animation: loading .7s infinite;
}
.loading span:nth-child(2) {
  animation-delay: .1s;
}
.loading span:nth-child(3) {
  animation-delay: .2s;
}
.loading span:nth-child(4) {
  animation-delay: .3s;
}
.loading span:nth-child(5) {
  animation-delay: .4s;
}
.loading span:nth-child(6) {
  animation-delay: .5s;
}
.loading span:nth-child(7) {
  animation-delay: .6s;
}
@keyframes loading {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-15px);
  }
}
.list {
  height: 80vh;
}
.chat-list-enter-active, .chat-list-leave-active {
  transition: all 1s;
}
.chat-list-enter, .chat-list-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.mogomogo-enter-active, .mogomogo-leave-active {
  transition: all 1s;
}
.mogomogo-enter, .mogomogo-leave-to {
  position: absolute;
  transform: scale(0);
}
.huyuu {
  animation: huwahuwa 2s ease-out;
  animation-iteration-count: infinite;
}
@keyframes huwahuwa {
  0% {
    transform: translateY(0px) scale(0.8);
  }
  50% {
    transform: translateY(-7.5px) scale(0.8);
  }
  100% {
    transform: translateY(0px) scale(0.8);
  }
}
.footer-area {
  display: flex;
  justify-content: space-between;
}
.left-block, .right-block {
  width: 96px;
}
.center-block {
  display: flex;
  justify-content: center;
  align-items: center;
}
.auto-button {
  border-radius: 16px;
}
.tap-box {
  position: absolute;
  bottom: 16px;
  left: 0;
  right: 0;
  margin: auto;
  height: 160px;
}
.auto-button-wrapper {
  position: absolute;
  bottom: 16px;
  right: 16px;
}
.workday-tooltip{
  position : relative;
  cursor   : pointer;
  display  : inline-block;
}
.tooltip-workday-message {
  display       : none;
  position      : absolute;
  color         : #fff;
  background    : #363636;
  padding       : 8px;
  font-size     : 12px;
  border-radius : 5px;
  width         : 200px;
  z-index       : 10;
  text-align: center;
}
.tooltip-workday-message:before {
  content    : "";
  position   : absolute;
  top        : -20px;
  left       : 10px;
  border     : 15px solid transparent;
  border-top : 15px solid #363636;
  transform  : rotateZ(180deg);
}
.workday-tooltip:hover .tooltip-workday-message{
  display : inline-block;
  top     : 34px;
  left    : -15px;
}
</style>



// WEBPACK FOOTER //
// src/views/Message/MessageView.vue